<template>
  <div v-if="answerId" v-loading="loading">
    <div
      class="flex justify-between items-center hover:bg-blue hover:bg-opacity-25"
    >
      <div class="jTit">多媒体资料</div>
      <el-button @click="() => (mediaContentShow = !mediaContentShow)" type="text">{{ mediaContentShow ? '收起' : '展开' }}</el-button>
    </div>
    <div class="musicBox" v-show="mediaContentShow">
      <!-- 点击预览 大图 -->
      <el-image-viewer
        v-if="showViewer"
        :initialIndex="curIndex"
        :on-close="closeViewer"
        :on-switch="onSwitch"
        :url-list="url"
        :z-index="5000"
      />
      <div class="musicTit">问卷图片</div>
      <el-table :data="imageSurveyUrlArr" border style="width: 100%">
        <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
        <el-table-column prop="date" align="center" label="位置">
          <template slot-scope="scope">
            <template>
              <span v-html="transformHtml(convertAnswerText(scope.row.text, answerContent))"></span>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="dates" align="center" label="资料名称">
          <template slot-scope="scope">
            <template>
              <span v-html="transformHtml(scope.row.name)"></span>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="资料">
          <template slot-scope="scope">
            <div class="demo-image__preview">
              <img
                style="width: 30px; height: 30px; cursor: pointer"
                v-for="(imgSrc, index) in scope.row.imgArr"
                :src="imgSrc"
                :key="index"
                :z-index="5000"
                @click="onPreview(imageSurveyUrlArr.indexOf(scope.row), 1)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="jTits">开放题和非开放题</div>
    <el-table :data="feikaiArr" border style="width: 100%" class="kf-table-class">
      <el-table-column label="序号" width="50">
        <template slot-scope="scope">
          {{ scope.row.questionNo }}
        </template>
      </el-table-column>
      <el-table-column prop="date" label="题干" width="300">
        <template slot-scope="scope">
          <template>
            <span
              v-html="
                transformHtml(
                  convertAnswerText(
                    scope.row.questionDetails &&
                      (scope.row.questionDetails.content.richText || scope.row.questionDetails.content.text),
                    answerContent
                  )
                )
              "
            >
            </span>
            <div style="display: flex; align-items: center">
              <div>
                <img-box :imgList="scope.row" :xArray="xArr" :getType="qType"></img-box>
              </div>
            </div>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="答案">
        <template slot-scope="scope">
          <template>
            <h1 class="question-description" v-if="scope.row.questionDetails && scope.row.questionDetails.note">{{ scope.row.questionDetails && scope.row.questionDetails.note }}</h1>
            <!-- 答案显示 -->
            <div v-if="isChoice(scope.row.questionType)">
              <span v-for="(v, i) in scope.row.items" :key="i">
                <span style="line-height: 30px"> {{ v.value }}</span>
              </span>
            </div>
            <!-- 临时增加 个人信息 相关功能的显示 -->
            <div v-if="(22 <= scope.row.questionType && scope.row.questionType <= 40) || scope.row.questionType == 109">
              <span style="display: block" v-for="(v, i) in scope.row.items" :key="i" v-html="transformHtml(v.value)"></span>
            </div>
            <MatrixSingleChoice v-if="scope.row.questionType === 5" :row-data="scope.row" :updateArr="xArr"></MatrixSingleChoice>
            <!-- 单选题修改 年龄32 学历34 性别27 行业37 职业38 婚姻39 个人月收入40 -->
            <SingleChoice
              v-if="scope.row.questionType === 1 || scope.row.questionType === 32
                || scope.row.questionType === 34 || scope.row.questionType === 27
                || scope.row.questionType === 37 || scope.row.questionType === 38
                || scope.row.questionType === 39 || scope.row.questionType === 40"
              :appendItems="getAppendItems(scope.row)"
              :allQuesionList="feikaiArr"
              :row-data="scope.row"
              :updateArr="xArr"
            ></SingleChoice>
            <!-- 多选题修改 -->
            <MultiChoice
              v-if="scope.row.questionType === 2"
              :appendItems="getAppendItems(scope.row)"
              :allQuesionList="feikaiArr"
              :row-data="scope.row"
              :updateArr="xArr"
            ></MultiChoice>
            <!-- 矩阵量表 修改 9 ,自定义量表(多题干) 修改 16-->
            <MatrixScale
              v-if="scope.row.questionType == 9 || scope.row.questionType == 16"
              :row-data="scope.row"
              :updateArr="xArr"
            ></MatrixScale>
            <!-- 单行量表 修改 21, 自定义量表 pc端修改, 15 NPS量表 修改 10-->
            <SingleScale
              v-if="scope.row.questionType === 21 || scope.row.questionType === 15 || scope.row.questionType === 10"
              :row-data="scope.row"
              :updateArr="xArr"
            ></SingleScale>
            <!-- 日期题 修改17，出生日期 29-->
            <DateSelect v-if="scope.row.questionType === 17 || scope.row.questionType === 29" :row-data="scope.row" :updateArr="xArr"></DateSelect>
            <!-- 下拉题单选 修改 12 -->
            <SingleSelect
              v-if="scope.row.questionType === 12"
              :appendItems="getAppendItems(scope.row)"
              :allQuesionList="feikaiArr"
              :row-data="scope.row"
              :updateArr="xArr"
            ></SingleSelect>
            <!-- 下拉题多选 修改 13 -->
            <MultipleSelect
              v-if="scope.row.questionType === 13"
              :appendItems="getAppendItems(scope.row)"
              :allQuesionList="feikaiArr"
              :row-data="scope.row"
              :updateArr="xArr"
            ></MultipleSelect>
            <!-- 矩阵下拉 106 兼容101 -->
            <MatrixSelect
              v-if="scope.row.questionType === 106 || (scope.row.questionType === 101 && isOldMatrixSelect(scope.row))"
              :row-data="scope.row"
              :updateArr="xArr"
            >
            </MatrixSelect>
            <!-- 矩阵填空 107 兼容101 -->
            <MatrixFill
              v-if="scope.row.questionType === 107 || (scope.row.questionType === 101 && isOldMatrixFill(scope.row))"
              :row-data="scope.row"
              :updateArr="xArr"
            >
            </MatrixFill>
            <!-- 级联题修改 3; 常住地 28; 户籍地 33(少一个填空题)； 大学专业35； 院校36-->
            <Linkage v-if="[3, 28, 33, 35, 36].includes(scope.row.questionType)" :row-data="scope.row" :updateArr="xArr"></Linkage>
            <!-- 矩阵多选题 修改 6 -->
            <MatrixMultipleChoice
              v-if="scope.row.questionType === 6"
              :row-data="scope.row"
              :updateArr="xArr"
            ></MatrixMultipleChoice>
            <!-- 比重题 104-->
            <MatrixGravity v-if="scope.row.questionType === 104" :row-data="scope.row" :updateArr="xArr"></MatrixGravity>
            <!-- 表格组合 110 兼容修改 -->
            <MatrixCompose v-if="scope.row.questionType === 110" :row-data="scope.row" :updateArr="xArr"></MatrixCompose>
            <!-- 矩阵滑动 103 -->
            <MatrixScroll v-if="scope.row.questionType === 103" :row-data="scope.row" :updateArr="xArr"></MatrixScroll>
            <!-- 多项填空  105 -->
            <MultipleBlanks v-if="scope.row.questionType === 105" :row-data="scope.row" :updateArr="xArr"></MultipleBlanks>
            <!-- 自增表格 102 -->
            <MatirxAuto v-if="scope.row.questionType === 102" :row-data="scope.row" :updateArr="xArr"></MatirxAuto>
            <!-- 填空4 姓名22 手机号23 24邮箱 31身份证号 -->
            <Blanks
              v-if="scope.row.questionType === 4 || scope.row.questionType === 7
              || scope.row.questionType === 8
              || scope.row.questionType === 22 || scope.row.questionType === 23 || scope.row.questionType === 24
              || scope.row.questionType === 31"
              :row-data="scope.row"
              :updateArr="xArr"
            ></Blanks>
            <!-- 排序题 11 -->
            <Sort v-if="scope.row.questionType === 11" :row-data="scope.row" :updateArr="xArr"></Sort>
            <!-- 可下载附件 112 -->
            <Downloadable v-if="scope.row.questionType === 112" :row-data="scope.row" :updateArr="xArr"></Downloadable>
            <!-- 分类题 111 -->
            <Classification v-if="scope.row.questionType === 111" :row-data="scope.row" :updateArr="xArr"></Classification>
            <!-- 图片选择 113 -->
            <ImageChoice v-if="scope.row.questionType === 113" :row-data="scope.row" :updateArr="xArr" />
            <!-- 图片选择117 -->
            <ImageMultipleChoice v-if="scope.row.questionType === 117" :row-data="scope.row" :updateArr="xArr" />
            <!-- 区块级联 114 -->
            <CascadeRegion v-if="scope.row.questionType === 114" :row-data="scope.row" :updateArr="xArr" />
            <!-- 加总题 119 -->
            <Total v-if="scope.row.questionType === 119" :row-data="scope.row" :updateArr="xArr" />
            <!-- maxDiff题 124 -->
            <MaxDiff v-if="scope.row.questionType === 124" :row-data="scope.row" :updateArr="xArr"/>

            <!-- 文件上传题 修改 18-->
            <div v-if="scope.row.questionType == 18 && scope.row && scope.row.items">
              <div v-for="(item, index) in scope.row.items" :key="index">
                <img
                  v-if="isImg(item.value)"
                  :src="_getDownloadUrl(item.value)"
                  @click="onPreview(index, 2, item)"
                  class="mr-1 cursor-pointer"
                  style="width: 20px"
                />
                <i v-else class="el-icon-document m-0 mr-1"></i>
                <a :href="isImg(item.value) ? 'javascript:;' : _getDownloadUrl(item.value)" :download="item.value">{{
                  ellipsisMiddle(getUrl(item.value), 3, 8)
                }}</a>
              </div>
            </div>
            <!-- 所在位置题 修改 @focus="onFocus"
                -->
            <div v-if="scope.row.questionType == 100">
              <el-input
                :value="(scope.row.items[0] && scope.row.items[0].value)"
                placeholder="请输入地点、街道等位置信息"
                @input="onChange($event, scope.row)"
                @focus="onFocus(scope.row)"
                @blur="onBlur(scope.row)"
              />
              <!-- v-if="pois.length&&selectListFlag" -->
              <ul v-if="pois.length && selectListFlag && questionId == scope.row.questonId" class="pos-group">
                <li v-for="poi in pois" :key="poi.id" @mousedown="onClickSelectValue(poi, scope.row)">
                  <i class="el-icon-location-outline"></i>{{ poi.name }}
                </li>
              </ul>
            </div>
            <!-- 手写签名 14 -->
            <div v-if="scope.row.questionType === 14">
              <el-image
                v-for="(item, index) in scope.row.items"
                :key="index"
                style="width: 30px; height: 30px"
                :z-index="5000"
                :src="_getDownloadUrl(item.value)"
                :preview-src-list="getDownloadList(scope.row.items, 'value')"
              />
            </div>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="score" label="得分" width="80">
        <template slot-scope="scope">
          {{ scope.row.score }}
        </template>
      </el-table-column>
      <el-table-column prop="duration" label="答题时长" width="100">
        <template slot-scope="scope"> {{ scope.row.duration / 1000 }}s </template>
      </el-table-column>
    </el-table>
    <!-- 多媒体编辑 视频\音频\图片 -->
    <el-dialog
      append-to-body
      class="upDialog"
      :title="dialogTitle"
      :visible.sync="multiMediaDialogVisible"
      width="50%"
      :destroy-on-close="true"
      @close="dialog_multi_media_close"
    >
      <el-upload
        class="upload-multi-media"
        :data="fileData"
        :with-credentials="true"
        :accept="acceptComp"
        drag
        action="/fill/api/v1/upload"
        :on-success="handleSuccess"
        :on-error="handleError"
        :on-remove="handleRemove"
        :before-upload="beforeUpload"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">{{ uploadLimitMsg }}</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="multiMediaDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialog_multi_media_confirm()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 录音转文字 对话框 -->
    <el-dialog title="录音转文字" :visible.sync="dialogToWord" width="50%" :append-to-body="true">
      <div style="width: 100%; display: flex; justify-content: space-between; margin-bottom: 20px">
        <el-select v-show="false" v-model="recordValue" placeholder="请选择题目">
          <el-option v-for="item in recordOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-button @click="dialogueSwap = !dialogueSwap">对话互换</el-button>
      </div>
      <el-scrollbar style="height: 325px">
        <ul class="record-content" v-for="(item, index) in dialogueData" :key="index">
          <li :class="dialogueSwap ? 'left-style' : 'right-style'" v-if="!item.ChannelId">
            <div class="profile-photo"></div>
            <span>{{ item.Text }}</span>
          </li>
          <li :class="dialogueSwap ? 'right-style' : 'left-style'" v-else>
            <div class="profile-photo"></div>
            <span>{{ item.Text }}</span>
          </li>
        </ul>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogToWord = false">关 闭</el-button>
      </span>
    </el-dialog>
    <audio-play
      v-if="currentAudio"
      :audio="currentAudio"
      :duringCallContent="duringCallContent"
      @closeAudioPlay="closeAudioPlay"
    ></audio-play>
  </div>
  <div v-else>
    <div class="no-data">无答卷详情内容，可切换查询条件继续审核</div>
  </div>
</template>
<script>
import { detail, getPasswordInfo, getAudioText } from '@/api/wenjuan/answerList'
import GDMap from './GDMap.vue'
import mixins from './mixins'
import { channel_list_options, typeConfig } from '@/components/survey-detail/config/index.js'
import vuedraggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import imgBox from './ImageBox'
import ElImageViewer from 'dygc-ui/packages/image/src/image-viewer'
import mapPositionMixin from './map-position' // 路径变更
import * as Components from './types'
import AudioPlay from './AudioPlay'
import {
  getQuestionNo,
  getColsestDif,
  isPreNo,
  getAppendItems,
  getAppendOptions,
  getRemainder,
  ellipsisMiddle
} from './detailMeans.js'
import { questionType } from '@dygc/question'
import { convertAnswerText } from '@/question/convert.js'
import { transformHtml } from '@/components/survey-detail/utils/index.js'
let choiceArr = [questionType.SINGLE_CHOICE, questionType.MULTIPLE_CHOICE, questionType.CITY_ADDRESS]
export default {
  mixins: [mixins, mapPositionMixin],
  components: {
    GDMap,
    vuedraggable,
    imgBox,
    ElImageViewer,
    AudioPlay,
    ...Components
  },
  props: {
    answerId: String
  },
  directives: {
    playbackRate(el, binding) {
      el.playbackRate = binding.value
    }
  },
  data() {
    return {
      loading: false,
      qType: 'title',
      qType1: 'radio',
      qType2: 'check',
      imagelist: [],
      // 倍速选项
      rateOptions: [
        {
          value: 0.5,
          label: '0.5倍速'
        },
        {
          value: 1.0,
          label: '1.0倍速'
        },
        {
          value: 1.5,
          label: '1.5倍速'
        },
        {
          value: 2.0,
          label: '2.0倍速'
        },
        {
          value: 4.0,
          label: '4.0倍速'
        },
        {
          value: 8.0,
          label: '8.0倍速'
        }
      ],
      // titleImg:Array,
      //含有图片的题干的内容
      titleImgRow: null,
      //含有图片的单选题选项内容
      radioImgRow: null,
      //含有图片的多选题选项内容
      checkImgRow: null,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      // rankingQuestion的row
      rankingQuestionRow: null,
      // 防止数据质控页面多次更新数据
      preventRankingQuestion: true,
      // 排序题答案
      rankingQuestion: [],
      // 防止数据质控页面多次更新数据
      preventMatrixMultiple: true,
      // 矩阵多选答案
      matrixMultiple: {},
      // 级联题内容
      cascadeRow: null,
      // 防止数据质控页面多次更新数据
      preventCascadeUpdate: true,
      // 级联题答案
      cascadeValue: [],
      // 级联题选项
      cascadeOptions: [],
      // 开放题修改答案数组
      xArr: [],
      // 经纬度
      lng: '',
      lag: '',
      // 问题与答案
      feikaiArr: [],
      audioUrls: [],
      videoUrls: [],
      imageGlobalUrls: [],
      imageSurveyUrlArr: [],
      signUrlArr: [],
      audio: {
        // 该字段是音频是否处于播放状态的属性
        playing: false
      },
      title: '数量',
      name: '',
      nameNo: '',
      rules: {
        // name: [
        //   { required: true, message: "请输入通过说明", trigger: "change" }
        // ],
        nameNo: [{ required: true, message: '请输入拒绝说明', trigger: 'change' }]
      },
      channel_list_options,
      typeConfig,
      wjName: '', //问卷名称
      ids: '', //暂定答卷ID
      answerContent: [],
      form: {
        answerID: '',
        quesName: '',
        zqd: '',
        taskName: '',
        answerType: '',
        // initialStatus: "",
        channel: '',
        endTime: '',
        upTime: '',
        titId: '',
        qd: '',
        user: '',
        superId: '',
        // superTel: "",
        dz: '',
        jwd: '',
        startExamTime: '',
        endUser: '',
        endExamTime: '',
        degree: '',
        answerTime: '',
        startTime: '',
        longTime: '',
        ip: '',
        // 答题样本 id name
        accountUserId: '',
        accountUsername: '',
        // 答题密码+附加属性
        password: '',
        property: '',
        // 样本属性
        relatedSampleId: '',
        sampleName: '',
        // 质控人
        auditId: '',
        auditName: '',
        auditTime: '',
        submitTime: '',
        // 调查员姓名
        interviewerName: '',
        // 调查员电话
        interviewerTelephone: ''
      },
      tableData: [],

      // ----20201116----
      fileData: {},
      audioFilesArr: [],
      imageFilesArr: [],
      videoFilesArr: [],
      multiMediaDialogVisible: false,
      multiMediaDataBAK_for_SUBMIT: [], // 用于临时备份 上次打开的多媒体数据，为了弹层取消时，还原数据用
      multiMediaDataBAK_for_LIST: [], // 用于临时备份 上次打开的多媒体数据，为了弹层取消时，还原数据用
      clickedConfirm: false, // 标记点击的确定 按钮 ；为了区分关闭的点击事件
      dialogTitle: '',
      multiMediaType: '',

      fileList: [],
      showViewer: false,
      url: [],
      currentImgName: '',
      curIndex: 0,
      quesType: 0,
      picItem: {},
      searchValue: '',
      selectListFlag: false,
      questionId: null,
      duringCallContent: [],
      isAlert: false,
      audios: [],
      amountIssue: 0,
      audioTime: 0,
      dialogToWord: false,
      recordOptions: [],
      recordValue: '',
      currentAudio: '',
      dialogueData: [],
      dialogueSwap: true, //对话互换,
      mediaContentShow: false
    }
  },
  computed: {
    acceptComp() {
      let acc = ''
      switch (this.multiMediaType) {
        case 'audio':
          acc = 'audio/aac'
          break
        case 'video':
          acc = 'video/mp4'
          break
        case 'image':
          acc = 'image/jpeg'
          break
      }
      return acc
    },
    uploadLimitMsg() {
      const msg = msg => `只能上传${msg}文件，且不超过100Mb`
      let res = ''
      switch (this.multiMediaType) {
        case 'audio':
          res = msg('aac')
          break
        case 'video':
          res = msg('mp4')
          break
        case 'image':
          res = msg('jpg/jpeg')
          break
      }
      return res
    },
    isOldMatrixSelect() {
      return function (row) {
        const qd = row.questionDetails
        return qd && qd.issue && qd.issue.cells[0].hasOwnProperty('items')
      }
    },
    isOldMatrixFill() {
      return function (row) {
        const qd = row.questionDetails
        return qd && qd.issue && qd.issue.cells[0].hasOwnProperty('fillContext')
      }
    },
    mediaLen() {
      return this.audioUrls.length + this.videoUrls.length + this.imageSurveyUrlArr.length + this.imageGlobalUrls.length
    }
  },
  provide() {
    return {
      transformHtml: transformHtml
    }
  },
  methods: {
    convertAnswerText,
    transformHtml,
    getQuestionNo,
    getColsestDif,
    isPreNo,
    closeAudioPlay() {
      this.currentAudio = ''
    },
    showAudioPlay(row) {
      this.currentAudio = row
    },
    //兼容pc/app 矩阵单选、NPS量表、矩阵量表、单行量表、自定义量表的答案的label返回值
    getNps(item1, row) {
      if (row && row.items && row.items[0]) {
        if (typeof row.items[0].value == 'string') {
          let str = ''
          row.items.map((item, index) => {
            if (item.value.indexOf('(') != -1) {
              if (
                row.questionType == 9 ||
                row.questionType == 21 ||
                row.questionType == 15 ||
                row.questionType == 16 ||
                row.questionType == 10
              ) {
                str = '(' + item.value?.split('(')[1]
              }
            } else {
              const labels = row.questionDetails.issue.labels
              const [a1, a2] = [labels[0].text, labels[labels.length - 1].text]
              str = '(' + [a1, a2].join('-') + ')'
            }
          })
          return item1.num + str
        }
      }
    },
    //获取单选带有图片的答案
    getImg(item) {
      var answerArr = ''
      if (item && item.content && item.content.image && item.content.image[0]) {
        answerArr = this._getDownloadUrl(item.content.image[0].url)
      }
      return answerArr
    },
    getAnswer(row, item) {
      var answerArr = []
      if (row && row.questionDetails && row.questionDetails.issue) {
        for (var i = 0; i < row.items.length; i++) {
          for (var j = 0; j < item.length; j++) {
            if (row.questionType == 2 || row.questionType == 11) {
              var issueId = row.items[i].optionId
              var itemId = item[j].id
            } else if (row.questionType == 5 || row.questionType == 6) {
              if (item == row.questionDetails.issue.items) {
                var issueId = row.items[i].colId
                var itemId = item[j].id
              } else if (item == row.questionDetails.issue.rows) {
                var issueId = row.items[i].rowId
                var itemId = item[j].row_id
              }
            }
            if (issueId == itemId) {
              // console.log(Array.isArray(a[j].content.image))
              if (Array.isArray(item[j].content.image) && item[j].content.image.length !== 0) {
                answerArr.push([
                  {
                    url: this._getDownloadUrl(item[j].content.image ? item[j].content.image[0].url : null),
                    richText: item[j].content.richText ? item[j].content.richText : null,
                    text: item[j].content.text ? item[j].content.text : null
                  }
                ])
              } else {
                answerArr.push([
                  {
                    richText: item[j].content.richText ? item[j].content.richText : null,
                    text: item[j].content.text
                  }
                ])
              }
            }
          }
        }
      }
      return answerArr
    },
    updateCustomScale(row) {
      row.items[0].optionId = row.items[0].value
      if (this.xArr.findIndex(it => it.questonId === row.questonId) === -1) {
        this.xArr.push(row)
      }
    },
    updateSingleScale(row) {
      row.items[0].optionId = row.items[0].value
      if (this.xArr.findIndex(it => it.questonId === row.questonId) === -1) {
        this.xArr.push(row)
      }
    },
    updateNPS(row) {
      row.items[0].optionId = row.items[0].value
      if (this.xArr.findIndex(it => it.questonId === row.questonId) === -1) {
        this.xArr.push(row)
      }
    },
    updateMatrixSingle(row, itemsIdx, colId) {
      row.items[itemsIdx].colId = colId
      // todo 没有改 答案items里的value
      if (this.xArr.find(it => it.questonId === row.questionId) === undefined) {
        this.xArr.push(row)
      }
    },
    isChoice(type) {
      return choiceArr.includes(type)
    },
    // 控制音频的播放与暂停
    startPlayOrPause() {
      return this.audio.playing ? this.pause() : this.play()
      //   this.play();
    },
    // 播放音频
    play() {
      this.$refs.audio.play()
    },
    // 暂停音频
    pause() {
      this.$refs.audio.pause()
    },
    // 当音频播放
    onPlay() {
      this.audio.playing = true
    },
    // 当音频暂停
    onPause() {
      this.audio.playing = false
    },
    // 音频canplay
    getDuration() {
      let audioArr = document.getElementsByClassName('audios')
      let time = 0
      Array.from(audioArr).forEach(element => {
        time += element.duration
      })
      this.audioTime = parseInt(time)
      let amountIssue = 0
      this.duringCallContent.answerContent.forEach(item => {
        item.questionType != 20 ? (amountIssue += 1) : ''
      })
      this.amountIssue = amountIssue
      this.isAlert = true
    },

    //  返回
    goBack() {
      this.$router.go(-1)
    },
    // 问卷问题及答案的重组
    quesFun(data) {
      this.feikaiArr = data.filter(item => {
        if (
          item.questionType == 1 ||
          item.questionType == 2 ||
          item.questionType == 3 ||
          item.questionType == 4 || // 开放题----填空题
          item.questionType == 7 || // 开放题----单行文本填充题
          item.questionType == 8 || // 开放题----多行文本填充题
          item.questionType == 5 ||
          item.questionType == 6 ||
          item.questionType == 9 ||
          item.questionType == 10 ||
          item.questionType == 11 ||
          item.questionType == 12 ||
          item.questionType == 13 ||
          item.questionType == 14 || // 手写签名
          item.questionType == 15 ||
          item.questionType == 16 ||
          item.questionType == 17 ||
          item.questionType == 18 ||
          item.questionType == 19 || // 详细地址
          item.questionType == 100 || // 所在位置
          item.questionType == 20 || // 描述题
          item.questionType == 21 ||
          item.questionType == 22 || // 姓名
          item.questionType == 23 || // 手机号
          item.questionType == 24 || // 邮箱
          item.questionType == 27 || // 性别
          item.questionType == 28 || // 常住地
          item.questionType == 29 || // 出生日期
          item.questionType == 31 || // 身份证
          item.questionType == 32 || // 年龄
          item.questionType == 33 || // 户籍
          item.questionType == 34 || // 学历
          item.questionType == 35 || // 大学专业
          item.questionType == 36 || // 院校
          item.questionType == 37 || // 所处行业
          item.questionType == 38 || // 职业
          item.questionType == 39 || // 婚姻状况
          item.questionType == 40 || // 个人月收入
          item.questionType == 101 || // 旧版题型（矩阵下拉，矩阵天空）兼容用
          item.questionType == 102 || // 自增表格
          item.questionType == 103 || // 矩阵滑动
          item.questionType == 104 || // 比重题
          item.questionType == 105 || // 多项填空
          item.questionType == 106 || // 矩阵下拉题
          item.questionType == 107 || // 矩阵填空题
          item.questionType == 109 || // 手机验证题
          item.questionType == 110 || // 表格组合
          item.questionType == 111 || //分类题
          item.questionType == 112 || // 可下载附件
          item.questionType == 113 || // 图片选择（单选）
          item.questionType == 117 || // 图片选择（多选）
          item.questionType == 109 || // 手机验证
          item.questionType == 114 || // 区块级联
          item.questionType == 119 ||// 加总题
          item.questionType == 124  //maxDiff
        ) {
          return item
        }
      })
      // this.$emit('allquestionlist', this.feikaiArr)
      // console.log(this.feikaiArr)
      this.feikaiArr.length && this.getQuestionNo()
    },
    bjAnswerBlur(i, row) {
      this.xArr.push(row)
      var obj = {}
      this.xArr = this.xArr.reduce(function (item, next) {
        // 设置一下 单选题的 结果中的value / 下拉单选
        if ((next.questionType === 1 || next.questionType === 12) && next.items && next.items.length > 0) {
          next.items[0].value = next.questionDetails.issue.items.find(item => {
            return item.id === next.items[0].optionId
          }).content.text
        }
        obj[next.questonId] ? '' : (obj[next.questonId] = true && item.push(next))
        return item
      }, [])
    },
    //=====各题型初始化===下==
    initData_2_13(item) {
      // 多选题2 下拉多选13
      if (item.questionType === 2 || item.questionType === 13) {
        // 根据问卷选项，存储 多选题 选项上传图片 并赋值 已有的photos字段
        this.$set(
          item,
          'tempPhotosItems',
          item.questionDetails.issue.items.map(its => {
            return {
              optionId: its.id,
              value: its.content.text,
              photos: [],
              rowId: null,
              colId: null
            }
          })
        )
        item.tempPhotosItems.forEach(its => {
          item.items.forEach(itts => {
            if (itts.optionId === its.optionId) {
              its.photos = itts.photos
            }
          })
          return its
        })
      }
    },
    // 2021.1.20 处理排序题 增加v-model的字段
    initData_3(item) {
      if (item.questionType === 3) {
        Object.defineProperty(item, '__cascadeValue', {
          value: item.items.map(i => i.optionId),
          enumerable: true,
          writable: true
        })
      }
    },
    //=====各题型初始化===上==
    handleFormData(data) {
      this.ids = data.id
      this.answerContent = data.answerContent
      this.form.answerID = data.id
      this.form.serialNumber = data.serialNumber // 流水编号
      this.form.quesName = data.surveyTitle
      this.form.answerType = data.status
      // this.form.initialStatus = data.initialStatus
      this.form.qd = this.channel_list_options[data.channel]
      this.form.channel = data.channel
      this.form.zqd = data.answerChannel
      this.form.taskName = data.taskName // 任务名称
      this.form.startTime = data.surveyStartTime
      this.form.endTime = data.surveyFinishTime
      this.form.upTime = data.submitTime //data.surveyFinishTime
      this.form.longTime = data.surveyDuration
      this.form.dz = data.answerAddress
      if (data.surveyLon == null || data.surveyLat == null) {
        this.form.jwd = ''
      } else {
        this.form.jwd = data.surveyLon + ',' + data.surveyLat
      }
      this.lng = data.surveyLon
      this.lag = data.surveyLat
      this.form.user = (data.supervisorId && data.supervisorId + '-' + data.supervisorName) || ''
      this.form.accountUserId = data.accountUserId
      this.form.accountUsername = data.accountUsername
      this.form.relatedSampleId = data.relatedSampleId // 样本id
      this.form.sampleName = data.sampleName // 样本名
      this.form.samplePhone = data.samplePhone // 样本电话
      this.form.sampleResidence = data.sampleResidence // 样本常住地址
      this.form.auditId = data.auditId // 质控员id
      this.form.auditName = data.auditName // 质控员
      this.form.auditTime = data.auditTime // 质控时间
      this.form.submitTime = data.submitTime // 提交时间
      this.form.ip = data.ipAddress
      this.form.user = data.supervisorName
      this.form.superId = data.supervisorId
      // this.form.superTel = data.supervisorTelephone
      this.form.startExamTime = data.reviewTime
      // 20200830 质控驳回时 显示原因
      this.form.degree = data.status === 10 ? data.rejectReason : data.auditDescription
      this.form.interviewerName = data.interviewerName
      this.form.interviewerTelephone = data.interviewerTelephone
      this.form.awardYuanAmount = data.awardYuanAmount // 普通红包
      this.form.shareAwardYuanAmount = data.shareAwardYuanAmount // 分享红包
      this.form.callee = data.callee // 相关手机号
      this.form.calleeName = data.calleeName // 被叫姓名
      // 整理 多选题2 下拉多选13 为了显示用
      // 20201223 解析 日期题数据 questionType === 17
      // 2021.1.20 处理级联题 3  增加v-model的字段
      // 2021.1.20 处理排序题 11 增加v-model的字段
      // 2021.1.20 处理矩阵多选题 6 增加v-model字段
      if (data.answerContent && data.answerContent.length > 0) {
        data.answerContent &&
          data.answerContent.map(item => {
            this.initData_2_13(item) // 不能删除 img组件里 使用了
            this.initData_3(item)
            // this.initData_11(item)
          })
      }
      //   音频重组
      this.audioUrlsFun(data)
      //   视频重组
      this.videoUrlsFun(data)
      //   图片重组（拆分为 全局图片和问卷图片）
      this.picGlobalFun(data)
      this.picSurveyFun(data)
      // 签名重组
      this.signFun(data)
      //   问卷问题及答案修改
      this.quesFun(data.answerContent)
      this.duringCallContent = data
    },
    getDetail(id) {
      this.loading = true
      this.$emit('loadingEnd', true)
      let detailPromise = detail(id)
      let getPasswrodInfoPromise = getPasswordInfo({ answerId: id })
      Promise.all([detailPromise, getPasswrodInfoPromise])
        .then(res => {
          // console.log('获取到的数据：', res);
          // 重置
          this.resetArr()
          this.handleFormData((res[0].data && res[0].data.data) || [])
          this.loading = false
          this.$emit('loadingEnd', false)

          if (res[1].data.data) {
            this.form.password = res[1].data.data.password || ''
            this.form.property = res[1].data.data.property || ''
          }
        })
        .catch(err => {
          this.loading = false
          this.$emit('loadingEnd', false)
          console.log(err)
        })
      // detail(id).then(res => {
      //   // 重置
      //   this.resetArr()
      //   this.handleFormData(res.data && res.data.data || [])
      //   this.loading = false
      //   this.$emit('loadingEnd', false)
      // }).catch(err => {
      //   this.loading = false
      //   this.$emit('loadingEnd', false)
      //   console.log(err)
      // })
    },
    // 新增多媒体 弹层
    addMultiMediaDialog(type) {
      this.multiMediaDialogVisible = true
      this.multiMediaType = type
      this.clickedConfirm = false // 重置
      // 标题 / 备份
      switch (type) {
        case 'video':
          this.dialogTitle = '新增视频'
          this.multiMediaDataBAK_for_SUBMIT = JSON.parse(JSON.stringify(this.videoFilesArr))
          this.multiMediaDataBAK_for_LIST = JSON.parse(JSON.stringify(this.videoUrls))
          break
        case 'audio':
          this.dialogTitle = '新增音频'
          this.multiMediaDataBAK_for_SUBMIT = JSON.parse(JSON.stringify(this.audioFilesArr))
          this.multiMediaDataBAK_for_LIST = JSON.parse(JSON.stringify(this.audioUrls))
          break
        case 'image':
          this.dialogTitle = '新增图片'
          this.multiMediaDataBAK_for_SUBMIT = JSON.parse(JSON.stringify(this.imageFilesArr))
          this.multiMediaDataBAK_for_LIST = JSON.parse(JSON.stringify(this.imageGlobalUrls))
          break
        default:
          break
      }
    },
    // 多媒体列表删除
    delMedia(row, type) {
      this.$confirm(`确认删除吗`, '资源删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.removeMedia(row, type)
          this.getDuration()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 处理列表中的删除 和 弹层中的上传文件删除
    removeMedia(row, type) {
      switch (type) {
        case 'video': {
          // 删除视频修改结果
          const idx = this.videoFilesArr.findIndex(item => {
            // 两种情况处理
            const url = row.mediaUrl || (row && row.response && row.response.data.url)
            return item === url
          })
          if (idx !== -1) {
            this.videoFilesArr.splice(idx, 1)
          }
          // 删除 视频表格中 数据
          const idx2 = this.videoUrls.findIndex(item => {
            const url = row.mediaUrl || (row && row.response && row.response.data.url)
            return item.mediaUrl === url
          })
          if (idx2 !== -1) {
            this.videoUrls.splice(idx2, 1)
          }
          break
        }
        case 'audio': {
          // 删除音频修改结果
          const idx = this.audioFilesArr.findIndex(item => {
            // 两种情况处理
            const url = row.mediaUrl || (row && row.response && row.response.data.url)
            return item === url
          })
          if (idx !== -1) {
            this.audioFilesArr.splice(idx, 1)
          }
          // 删除 音频表格中 数据
          const idx2 = this.audioUrls.findIndex(item => {
            const url = row.mediaUrl || (row && row.response && row.response.data.url)
            return item.mediaUrl === url
          })
          if (idx2 !== -1) {
            this.audioUrls.splice(idx2, 1)
          }
          break
        }
        case 'image': {
          // 删除图片修改结果
          const idx = this.imageFilesArr.findIndex(item => {
            // 两种情况处理
            const url = row.mediaUrl || (row && row.response && row.response.data.url)
            return item === url
          })
          if (idx !== -1) {
            this.imageFilesArr.splice(idx, 1)
          }
          // 删除 图片表格中 数据
          const idx2 = this.imageGlobalUrls.findIndex(item => {
            const url = row.mediaUrl || (row && row.response && row.response.data.url)
            // console.log(url);
            return item.mediaUrl === url
          })
          if (idx2 !== -1) {
            this.imageGlobalUrls.splice(idx2, 1)
          }
          break
        }
        default:
          break
      }
    },
    beforeUpload(file) {
      const isLt100M = file.size / 1024 / 1024 / 100 < 1
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      // console.log(file.type)
      switch (this.multiMediaType) {
        case 'video': {
          if (file.type !== 'video/mp4') {
            this.$message.error('只能上传mp4文件')
            return false
          }
          break
        }
        case 'audio': {
          if (file.type !== 'audio/aac' && file.type !== 'audio/vnd.dlna.adts') {
            this.$message.error('只能上传aac文件')
            return false
          }
          break
        }
        case 'image': {
          if (file.type !== 'image/jpeg') {
            this.$message.error('只能上传jpg/jpeg文件')
            return false
          }
          break
        }
      }
      return true
    },
    // 多媒体弹层的 任何关闭 事件 （包括 确定按钮）
    dialog_multi_media_close() {
      // 确定按钮以外 还原 进入时的数据
      if (!this.clickedConfirm) {
        // 视频
        if (this.multiMediaType === 'video') {
          this.videoFilesArr = JSON.parse(JSON.stringify(this.multiMediaDataBAK_for_SUBMIT))
          this.videoUrls = JSON.parse(JSON.stringify(this.multiMediaDataBAK_for_LIST))
        }
        // 音频
        if (this.multiMediaType === 'audio') {
          this.audioFilesArr = JSON.parse(JSON.stringify(this.multiMediaDataBAK_for_SUBMIT))
          this.audioUrls = JSON.parse(JSON.stringify(this.multiMediaDataBAK_for_LIST))
        }
        // 图片
        if (this.multiMediaType === 'image') {
          this.imageFilesArr = JSON.parse(JSON.stringify(this.multiMediaDataBAK_for_SUBMIT))
          this.imageGlobalUrls = JSON.parse(JSON.stringify(this.multiMediaDataBAK_for_LIST))
        }
      }
    },
    // 确定
    dialog_multi_media_confirm() {
      // 设置 视频列表数据
      this.clickedConfirm = true // 标记点击的确定
      // 关闭 ，触发关闭事件
      this.multiMediaDialogVisible = false
    },
    // 多媒体资源上传成功
    handleSuccess(res, file, fileList) {
      // code !== 0时，上传也失败，从fileList中移除文件
      // console.log(res,file);
      if (res && res.code !== 0) {
        // 错误提示
        this.$message.error(res.msg)
        // 删除
        const idx = fileList.findIndex(item => {
          return item.uid === file.uid
        })
        fileList.splice(idx, 1)
      }
      // 设置单条数据
      this.setMultiMediaData(file)
    },
    setTitleRow(fileList, type, index) {
      let url1 = []
      for (var i = 0; i < fileList.length; i++) {
        if (fileList[i].response) {
          url1.push(fileList[i].response.data.url)
        } else {
          url1.push(fileList[i].url?.split('=')[1])
        }
      }
      const photos = url1
      if (type == 'title') {
        this.titleImgRow.activePhotoFiles = photos
        if (this.xArr.findIndex(it => it.questonId === this.titleImgRow.questonId) === -1) {
          this.xArr.push(this.titleImgRow)
        }
      } else if (type == 'radio') {
        this.radioImgRow.items[0].photos = photos
        if (this.xArr.findIndex(it => it.questonId === this.radioImgRow.questonId) === -1) {
          this.xArr.push(this.radioImgRow)
        }
      } else if (type == 'check') {
        this.checkImgRow.tempPhotosItems[index].photos = photos
        this.checkImgRow.items.forEach(item => {
          if (item.optionId === this.checkImgRow.tempPhotosItems[index].optionId) {
            item.photos = photos
            const idIdx = this.xArr.findIndex(it => it.questonId === this.checkImgRow.questonId)
            if (idIdx === -1) {
              this.xArr.push(this.checkImgRow)
            } else {
              this.xArr.splice(idIdx, 1, this.checkImgRow)
            }
          }
        })
      }
    },
    handleSuccess1(res, file, fileList, row, type) {
      this.titleImgRow = row
      if (res && res.code !== 0) {
        // 错误提示
        this.$message.error(res.msg)
        // 删除
        const idx = fileList.findIndex(item => {
          return item.uid === file.uid
        })
        fileList.splice(idx, 1)
      }
      //  console.log(JSON.stringify(row,null,2));
      row.activePhotoFiles.push(file.response.data.url)
      //  console.log(JSON.stringify(row,null,2));
      this.setTitleRow(fileList, type)
    },
    handleRadioSuccess1(res, file, fileList, row, type) {
      this.radioImgRow = row
      if (res && res.code !== 0) {
        // 错误提示
        this.$message.error(res.msg)
        // 删除
        const idx = fileList.findIndex(item => {
          return item.uid === file.uid
        })
        fileList.splice(idx, 1)
      }
      this.setTitleRow(fileList, type)
    },
    handleCheckSuccess1(res, file, fileList, row, type, index) {
      this.checkImgRow = row
      if (res && res.code !== 0) {
        // 错误提示
        this.$message.error(res.msg)
        // 删除
        const idx = fileList.findIndex(item => {
          return item.uid === file.uid
        })
        fileList.splice(idx, 1)
      }
      this.setTitleRow(fileList, type, index)
    },
    handleRemove3(file, fileList, row, type) {
      this.titleImgRow = row
      this.setTitleRow(fileList, type)
    },
    handleRadioRemove3(file, fileList, row, type) {
      this.radioImgRow = row
      this.setTitleRow(fileList, type)
    },
    handleCheckRemove3(file, fileList, row, type, index) {
      this.checkImgRow = row
      this.setTitleRow(fileList, type, index)
    },
    handlePictureCardPreview(file, fileList) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforeUpload1(file) {
      const isLt100M = file.size / 1024 / 1024 / 100 < 1
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/x-ms-bmp') {
        this.$message.error('只能上传jpg/jpeg/png/bmp文件')
        return false
      }
    },
    getDownloadList(list, tag = 'url') {
      let imgList = list.map(item => {
        return this._getDownloadUrl(item[tag])
      })
      return imgList
    },
    radioFileList(row, type, index) {
      // console.log(index);
      if (row && row.items) {
        let url = null
        if (type == 'radio') {
          if (row.items[0] && row.items[0].photos) {
            url = row.items[0].photos.map(item => {
              return {
                url: this._getDownloadUrl(item)
              }
            })
            return url
          }
        } else if (type == 'title') {
          if (row.activePhotoFiles) {
            url = row.activePhotoFiles.map(item => {
              return {
                url: this._getDownloadUrl(item)
              }
            })
            return url
          }
        } else if (type == 'check') {
          if (row.questionDetails && row.questionDetails.issue && row.questionDetails.issue.items) {
            for (let i = 0; i < row.tempPhotosItems.length; i++) {
              if (row.questionDetails.issue.items[index].id == row.tempPhotosItems[i].optionId) {
                url = (row.tempPhotosItems[i].photos || []).map(item => {
                  return {
                    url: this._getDownloadUrl(item)
                  }
                })
                //  console.log(url);
                return url
              }
            }
          }
        }
      } else if (row && row.url) {
        let nameUrl = null
        if (type == 'name') {
          if (row.url) {
            nameUrl = row.url.map(item => {
              return {
                url: this._getDownloadUrl(item)
              }
            })
            return nameUrl
          }
        }
      }
    },
    setMultiMediaData(file) {
      // 整理数据
      // 视频
      if (this.multiMediaType === 'video') {
        // 列表展示数据
        this.videoUrls.push({
          text: '全程',
          id: this.ids,
          mediaUrl: file.response.data.url,
          name: `${this.form.quesName}视频${this.videoUrls.length + 1}${this.ids}`,
          imgArr: this._getDownloadUrl(file.response.data.url)
        })
        // 视频 提交数据（4个按钮）
        this.videoFilesArr.push(file.response.data.url)
        // 音频
      } else if (this.multiMediaType === 'audio') {
        const s = this.audioUrls.length
        // 列表展示数据
        this.audioUrls.push({
          text: '全程',
          id: this.ids,
          mediaUrl: file.response.data.url,
          name: `${this.form.quesName}音频${s + 1}${this.ids}`,
          imgArr: this._getDownloadUrl(file.response.data.url),
          dltext: this._getDownloadUrl(file.response.data.url, 'isAudio', `${this.form.quesName}音频${s + 1}${this.ids}`)
        })
        // 音频 提交数据（4个按钮）
        this.audioFilesArr.push(file.response.data.url)

        // 图片(全局)
      } else if (this.multiMediaType === 'image') {
        // 列表展示数据
        this.imageGlobalUrls.push({
          text: '全程',
          id: this.ids,
          mediaUrl: file.response.data.url,
          name: this.form.quesName + '图片' + this.ids,
          imgArr: this._getDownloadUrl(file.response.data.url)
        })
        // 图片 提交数据（4个按钮）
        this.imageFilesArr.push(file.response.data.url)
        // console.log(this.imageGlobalUrls);
      }
    },
    // 上传组件的删除
    handleRemove(file, fileList) {
      this.removeMedia(file, this.multiMediaType)
    },
    handleError(err, file, fileList) {
      this.$message.error(err && err.msg)
    },
    getUrl(item) {
      const index = item.lastIndexOf('/')
      return item.slice(index + 1)
    },
    isImg(url) {
      //文件路径
      var fileName = url
      //后缀获取
      let suffix = ''
      // 获取类型结果
      let result = ''
      const flieArr = fileName?.split('.')
      suffix = flieArr[flieArr.length - 1]
      if (suffix != '') {
        suffix = suffix.toLocaleLowerCase()
        // 图片格式
        const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
        // 进行图片匹配
        result = imglist.find(item => item === suffix)
        if (result) {
          return true
        } else {
          return false
        }
      }
    },
    onPreview(index, type, item) {
      if (type == 1) {
        let num = 0
        for (let i = 0; i <= index; i++) {
          if (!this.imageSurveyUrlArr[i].imgArr.length) {
            num++
          }
        }
        index -= num
      }
      this.showViewer = true
      this.curIndex = index
      this.quesType = type
      this.picItem = item
      this.additional(index)
    },
    additional(index) {
      this.url = []
      if (this.quesType == 1) {
        for (let i = 0; i < this.imageSurveyUrlArr.length; i++) {
          if (this.imageSurveyUrlArr[i].imgArr.length) {
            this.url.push(this.imageSurveyUrlArr[i].imgArr[0])
            this.currentImgName = this.imageSurveyUrlArr[index].name
          }
        }
      }
      if (this.quesType == 2) {
        for (let i = 0; i < this.feikaiArr.length; i++) {
          if (this.feikaiArr[i].questionType == 18 && this.feikaiArr[i].items.indexOf(this.picItem) >= 0) {
            for (let j = 0; j < this.feikaiArr[i].items.length; j++) {
              this.url.push(this._getDownloadUrl(this.feikaiArr[i].items[j].value))
              this.currentImgName = this.getUrl(this.feikaiArr[i].items[index].value)
            }
          }
        }
      } else if (this.quesType == 3) {
        for (let i = 0; i < this.imageGlobalUrls.length; i++) {
          if (this.imageGlobalUrls[i].imgArr) {
            this.url.push(this.imageGlobalUrls[i].imgArr)
            this.currentImgName = this.imageGlobalUrls[index].name
          }
        }
      }
      this.addNode()
    },

    // 关闭查看器
    closeViewer() {
      this.showViewer = false
    },
    addNode() {
      this.$nextTick(() => {
        if (document.getElementById('newNode')) {
          document.getElementById('newNode').remove()
        }
        let fatherNode = document.getElementsByClassName('el-image-viewer__canvas')
        let afterNode = document.getElementsByClassName('el-image-viewer__img')
        let newNode = document.createElement('div')
        newNode.innerText = '资料名称：' + this.currentImgName
        newNode.style.cssText =
          'color:#fff; font-size:14px;  text-align: center; position: absolute; top:13px; width:auto; z-index:5000; background: rgba(000,000,000,0.38); padding:0px 10px; border-bottom-right-radius: 12px; border-radius: 12px;'
        newNode.setAttribute('id', 'newNode')
        fatherNode[0].insertBefore(newNode, afterNode[0])
      })
    },
    onSwitch(index) {
      this.additional(index)
    },
    onFocus(row) {
      this.selectListFlag = true
      this.questionId = row.questonId
      this.getList(row.items[0]?.value)
    },
    onChange(val, row) {
      row.items = [
        {
          ...row.items[0] ?? {},
          value: val
        }
      ]
      this.searchValue = val
    },
    onBlur(row) {
      this.selectListFlag = false
      let ids = this.xArr.indexOf(row)
      if (ids >= 0) {
        this.xArr.splice(ids, 1, row)
      } else {
        this.xArr.push(row)
      }
    },
    onClickSelectValue(poi, row) {
      this.searchValue = poi.name
      for (let i = 0; i < this.feikaiArr.length; i++) {
        if (this.feikaiArr[i].questionType == 100 && row.questonId == this.feikaiArr[i].questonId) {
          this.feikaiArr[i].items[0].value = poi.name
        }
      }
      // this.changeIssueValue(poi)
      this.selectListFlag = false
    },
    onRefresh(aId) {
      if (aId) this.getDetail(aId)
    },
    resetArr() {
      this.xArr = []
      this.audioUrls = []
      this.imageGlobalUrls = []
      this.videoUrls = []
      this.signUrlArr = []
      this.audioFilesArr = []
      this.imageFilesArr = []
      this.videoFilesArr = []
    },
    // 录音转文字
    handelAudioText(media) {
      getAudioText({ fileName: media })
        .then(res => {
          this.dialogueData = JSON.parse(res.data.data).Result.Sentences
          this.dialogToWord = true
        })
        .catch(err => {
          this.$message.error('转换失败')
        })
    },
    //获得关联题选项
    getAppendItems,
    getAppendOptions,
    getRemainder,
    //省略字符串中间字符的方法
    ellipsisMiddle
  },
  created() {
    if (this.answerId) {
      this.getDetail(this.answerId)
    }
  },
  watch: {
    answerId(n) {
      if (n) this.getDetail(n)
    },
    rate(n) {
      this.$refs.audio.playbackRate = n
    },
    searchValue(val) {
      this.getList(val)
    }
  }
}
</script>
<style scoped lang="scss">
// 开发题 答案列 加滚动条
.kf-table-class {
  ::v-deep .el-table__row {
    .cell {
      overflow-x: auto;
    }
  }
  ::v-deep .cell {
    line-height: 40px;
  }
}
.no-data {
  height: 100px;
  line-height: 100px;
  text-align: center;
  font-size: 20px;
  color: #227ffe;
}
.headerTitle {
  text-align: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  font-weight: bolder;
  border-bottom: solid 1px #ebeef5;
  position: relative;

  .btnBox {
    display: inline-block;
    position: absolute;
    right: 0px;
    top: -13px;
  }
}

.content {
  font-weight: normal;
  color: #ccc;

  span {
    padding: 0 10px;
    font-weight: normal;
    font-size: 14px;
    color: #000;
  }

  b {
    padding-left: 10px;
    color: #000;
  }
}


.jT_content {
  .jT_c_s {
    padding: 16px 10px;
    border-bottom: solid 1px #e8e8e8;

    .el-col {
      margin-top: 16px;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      span {
        color: rgba(0, 0, 0, 0.65);
      }
      &.quesName {
        .label {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          width: 70px;
        }
        span {
          max-width: calc(100% - 70px);
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .jT_c_z {
    display: flex;
    padding: 16px 10px;
    border-bottom: solid 1px #e8e8e8;

    .left {
      flex: 2;
      height: 380px;

      p {
        margin-top: 10px;
        height: 22px;
        line-height: 22px;
        .d {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
        }
        span {
          line-height: 22px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;
          padding-left: 5px;
          font-size: 14px;
          font-family: HelveticaNeue;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }

    .right {
      flex: 3;
      height: 380px;
    }
  }

  .jT_c_x {
    padding: 5px 10px;
    min-height: 50px;
    display: table;
    p {
      line-height:120%;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      display: table-cell;
      vertical-align:middle;
      span {
        padding-left: 5px;
        font-size: 14px;
        font-family: HelveticaNeue;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}

.jTit {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 49, 50, 1);
}

.jTits {
  margin-top: 10px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 49, 50, 1);
  height: 50px;
  line-height: 50px;
}

.musicBox {
  width: 100%;

  .musicTit {
    height: 50px;
    line-height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  // >>> .vueAudioNative {
  audio {
    width: 100%;
  }
  // }
}
.inputs ::v-deep .el-input__inner {
  border: none !important;
  background: #fff !important;
}

.el-form-item {
  margin-bottom: 0;
}

// 音频
.el-table ::v-deep .cell {
  position: relative;
}
::v-deep.el-image-viewer__btn,
.el-image-viewer__close {
  // background: transparent!important;
  // right: 200px;
  .el-icon-circle-close,
  .el-icon-close {
    color: white;
  }
}

.audios {
  height: 30px;
}

.audioA {
  position: absolute;
  left: 20px;
  top: 5px;
}

.videoDialog ::v-deep .el-dialog {
  width: 100%;
  height: 100%;
}

.videoDialog ::v-deep .el-dialog__header {
  background: black;
  padding-bottom: 30px;
}

.videoDialog ::v-deep .el-dialog__body {
  padding: 0;
  background: black;
}
// 矩阵-单选-修改
.cell {
  span {
    .matrix-single {
      margin-bottom: 15px;
      > h1 {
        font: 400 14px/1 '微软雅黑';
      }
    }
    &:first-of-type {
      .matrix-single {
        > h1 {
          margin-top: 0;
        }
      }
    }
    &:last-of-type {
      .matrix-single {
        margin: 0;
      }
    }
  }
}
// NPS量表Items样式
.nps-table-items,
  // 单行量表Items样式
  .single-scale-items,
  // 自定义量表Items样式
  .custom-scale-items {
  margin: 5px 10px;
}
// 矩阵量表样式
.matrix-scale {
  > h1 {
    font: 400 14px/1 '微软雅黑';
  }
}
// 问题描述样式
.question-description {
  padding-bottom: 10px;
  // border-bottom: 1px solid #ebeef5;
}
// 问题多题干样式
.mini-question-description {
  display: flex;
  align-items: center;
}
// 排序题样式
.ranking-question-box {
  .chosen {
    .item {
      padding: 6px;
      background-color: #fdfdfd;
      border: solid 1px #eee;
      margin-bottom: 10px;
      cursor: move;
      display: flex;
      align-items: center;
    }
    .item:hover {
      background-color: #f1f1f1;
      cursor: move;
    }
  }
}
.upDialog {
  .upload-multi-media {
    text-align: center;
  }
}
.box {
  ::v-deep.el-checkbox__label {
    display: flex;
    align-items: center;
  }
}
::v-deep.el-radio-group {
  ::v-deep.el-radio__label {
    display: flex;
    align-items: center;
  }
}
// NPS量表和矩阵量表的选项按钮不在一行
.matrix-nps-scale.el-radio-group {
  ::v-deep.el-radio__label {
    vertical-align: middle;
    white-space: normal;
    max-width: 200px;
    display: inline-block;
  }
}
//上传图片样式
.avatar-uploader {
  ::v-deep .el-upload-list__item {
    transition: none !important;
  }
  ::v-deep.el-upload-list .el-upload-list--picture-card {
    display: none !important;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    height: 80px;
    width: 80px;
    transition: none !important;
  }
  ::v-deep.el-upload-list {
    li {
      height: 80px;
      width: 80px;
    }
  }
  ::v-deep.el-upload--picture-card {
    height: 80px;
    width: 80px;
    line-height: 90px;
  }
}
::v-deep.el-image-viewer__img {
  width: 50% !important;
  height: auto !important;
  position: absolute !important;
  top: 40px;
}
// 所在位置 修改
ul li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pos-group {
  margin-top: 0;
  box-sizing: border-box;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  max-height: 180px;
  overflow-y: auto;
  background-color: #fff;
  /*@apply bolder-1 border-gray-300 border-solid;*/
  @apply rounded;
  li {
    cursor: pointer;
    border-bottom: 1px solid #eaeaea;
    padding-right: 20px;
    line-height: 36px;
    font-size: 14px;
    @apply py-2 text-gray-500;
    &:last-child {
      border-bottom: none;
    }
  }
}
.alert-style {
  color: #000;
  font-size: 16px;
  font-weight: 400;
}
::v-deep.el-alert--warning.is-light {
  background-color: rgb(252, 248, 228);
  border: 1px solid rgb(254, 228, 148);
  margin-bottom: 10px;
}
::v-deep.el-alert--info.is-light {
  background-color: rgb(231, 247, 255);
  border: 1px solid rgb(148, 214, 253);
  margin-bottom: 10px;
}
::v-deep.el-icon-document {
  font-size: 20px;
  margin: 8px 0 0 10px;
  cursor: pointer;
  color: rgb(37, 147, 252);
}
.record-content {
  width: 100%;
  // border: 1px solid blue;
  // margin-top: 25px;
  // height: 300px;
  // overflow-y: scroll;
  // position: relative;
  .left-style {
    width: 70%;
    // border: 1px solid #ccc;
    display: flex;
    justify-content: start;
    margin-bottom: 25px;
    // float: left;
    .profile-photo {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      // display: inline-block;
      background: #ccc;
      border-radius: 50%;
    }
    span {
      position: relative;
      margin-left: 15px;
      background: #eee;
      border-radius: 9px;
      padding: 6px;
      color: #000;
    }
    span:before {
      content: '';
      position: absolute;
      top: 16px;
      left: -15px;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-left: 8px solid transparent;
      border-right: 8px solid #eee;

      // background:#25a7ce;
    }
  }
  .right-style {
    width: 70%;
    margin-left: 30%;
    // border: 1px solid #ccc;
    display: flex;
    flex-direction: row-reverse;
    // justify-content: end;
    margin-bottom: 25px;
    // float: right;
    .profile-photo {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      // display: inline-block;
      background: rgb(152, 240, 48);
      border-radius: 50%;
    }
    span {
      position: relative;
      margin-right: 15px;
      background: rgb(152, 240, 48);
      border-radius: 9px;
      padding: 6px;
      color: #000;
    }
    span:after {
      content: '';
      position: absolute;
      top: 16px;
      right: -15px;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-right: 8px solid transparent;
      border-left: 8px solid rgb(152, 240, 48);
      // background:#25a7ce;
    }
  }
}
::v-deep.el-table__row .cell {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
<style>
.el-select-dropdown.dropdown-limit-width {
  max-width: 800px;
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
